import { FC } from 'react';
import {
  BarChartOutlined,
  BookOutlined,
  LogoutOutlined,
  PieChartOutlined,
  SettingOutlined,
} from '@ant-design/icons';

export const GroupIcons = {
  tasks: <BookOutlined />,
  statistics: <BarChartOutlined />,
  analytics: <PieChartOutlined />,
  settings: <SettingOutlined />,
  logout: <LogoutOutlined />,
};

export const BrandLogo: FC = () => (
  <svg
    width="30"
    height="36"
    viewBox="0 0 43 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <line
      x1="4"
      y1="35"
      x2="4"
      y2="17"
      stroke="#3B82F6"
      strokeWidth="8"
      strokeLinecap="round"
    />
    <line
      x1="15.375"
      y1="41.5"
      x2="15.375"
      y2="10.5"
      stroke="#2563EB"
      strokeWidth="8"
      strokeLinecap="round"
    />
    <line
      x1="26.75"
      y1="48"
      x2="26.75"
      y2="4"
      stroke="#1D4ED8"
      strokeWidth="8"
      strokeLinecap="round"
    />
    <line
      x1="38.125"
      y1="38.25"
      x2="38.125"
      y2="13.75"
      stroke="#2563EB"
      strokeWidth="8"
      strokeLinecap="round"
    />
  </svg>
);

export const SipAccountsIcon: FC = () => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <rect width="50" height="50" rx="11" fill="#155DFC" />
    <g clipPath="url(#clip0_sip_accounts)">
      <path
        d="M37.5 18.375C38.5355 18.375 39.375 17.5355 39.375 16.5C39.375 15.4645 38.5355 14.625 37.5 14.625C36.4645 14.625 35.625 15.4645 35.625 16.5C35.625 17.5355 36.4645 18.375 37.5 18.375Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.125 18.375C42.0418 18.5635 42.017 18.7726 42.0537 18.9754C42.0905 19.1781 42.1872 19.3652 42.3312 19.5125L42.3687 19.55C42.485 19.6661 42.5772 19.804 42.6401 19.9557C42.703 20.1074 42.7354 20.2701 42.7354 20.4344C42.7354 20.5986 42.703 20.7613 42.6401 20.913C42.5772 21.0648 42.485 21.2027 42.3687 21.3187C42.2527 21.435 42.1148 21.5272 41.963 21.5901C41.8113 21.653 41.6486 21.6854 41.4844 21.6854C41.3201 21.6854 41.1574 21.653 41.0057 21.5901C40.854 21.5272 40.7161 21.435 40.6 21.3187L40.5625 21.2812C40.4152 21.1372 40.2281 21.0405 40.0254 21.0037C39.8226 20.967 39.6135 20.9918 39.425 21.075C39.2401 21.1542 39.0825 21.2858 38.9714 21.4535C38.8604 21.6211 38.8008 21.8176 38.8 22.0187V22.125C38.8 22.4565 38.6683 22.7745 38.4339 23.0089C38.1995 23.2433 37.8815 23.375 37.55 23.375C37.2185 23.375 36.9005 23.2433 36.6661 23.0089C36.4317 22.7745 36.3 22.4565 36.3 22.125V22.0687C36.2952 21.8619 36.2282 21.6612 36.1078 21.4929C35.9874 21.3246 35.8192 21.1964 35.625 21.125C35.4365 21.0418 35.2274 21.017 35.0246 21.0537C34.8219 21.0905 34.6348 21.1872 34.4875 21.3312L34.45 21.3687C34.3339 21.485 34.196 21.5772 34.0443 21.6401C33.8926 21.703 33.7299 21.7354 33.5656 21.7354C33.4014 21.7354 33.2387 21.703 33.0869 21.6401C32.9352 21.5772 32.7973 21.485 32.6812 21.3687C32.565 21.2527 32.4728 21.1148 32.4099 20.963C32.347 20.8113 32.3146 20.6486 32.3146 20.4844C32.3146 20.3201 32.347 20.1574 32.4099 20.0057C32.4728 19.854 32.565 19.7161 32.6812 19.6L32.7187 19.5625C32.8628 19.4152 32.9595 19.2281 32.9963 19.0254C33.033 18.8226 33.0082 18.6135 32.925 18.425C32.8458 18.2401 32.7142 18.0825 32.5465 17.9714C32.3789 17.8604 32.1824 17.8008 31.9812 17.8H31.875C31.5435 17.8 31.2255 17.6683 30.9911 17.4339C30.7567 17.1995 30.625 16.8815 30.625 16.55C30.625 16.2185 30.7567 15.9005 30.9911 15.6661C31.2255 15.4317 31.5435 15.3 31.875 15.3H31.9312C32.1381 15.2952 32.3388 15.2282 32.5071 15.1078C32.6754 14.9874 32.8036 14.8192 32.875 14.625C32.9582 14.4365 32.983 14.2274 32.9463 14.0246C32.9095 13.8219 32.8128 13.6348 32.6687 13.4875L32.6312 13.45C32.515 13.3339 32.4228 13.196 32.3599 13.0443C32.297 12.8926 32.2646 12.7299 32.2646 12.5656C32.2646 12.4014 32.297 12.2387 32.3599 12.0869C32.4228 11.9352 32.515 11.7973 32.6312 11.6812C32.7473 11.565 32.8852 11.4728 33.0369 11.4099C33.1887 11.347 33.3514 11.3146 33.5156 11.3146C33.6799 11.3146 33.8426 11.347 33.9943 11.4099C34.146 11.4728 34.2839 11.565 34.4 11.6812L34.4375 11.7187C34.5848 11.8628 34.7719 11.9595 34.9746 11.9963C35.1774 12.033 35.3865 12.0082 35.575 11.925H35.625C35.8099 11.8458 35.9675 11.7142 36.0786 11.5465C36.1896 11.3789 36.2492 11.1824 36.25 10.9812V10.875C36.25 10.5435 36.3817 10.2255 36.6161 9.99112C36.8505 9.7567 37.1685 9.625 37.5 9.625C37.8315 9.625 38.1495 9.7567 38.3839 9.99112C38.6183 10.2255 38.75 10.5435 38.75 10.875V10.9312C38.7508 11.1324 38.8104 11.3289 38.9214 11.4965C39.0325 11.6642 39.1901 11.7958 39.375 11.875C39.5635 11.9582 39.7726 11.983 39.9754 11.9463C40.1781 11.9095 40.3652 11.8128 40.5125 11.6687L40.55 11.6312C40.6661 11.515 40.804 11.4228 40.9557 11.3599C41.1074 11.297 41.2701 11.2646 41.4344 11.2646C41.5986 11.2646 41.7613 11.297 41.913 11.3599C42.0648 11.4228 42.2027 11.515 42.3187 11.6312C42.435 11.7473 42.5272 11.8852 42.5901 12.0369C42.653 12.1887 42.6854 12.3514 42.6854 12.5156C42.6854 12.6799 42.653 12.8426 42.5901 12.9943C42.5272 13.146 42.435 13.2839 42.3187 13.4L42.2812 13.4375C42.1372 13.5848 42.0405 13.7719 42.0037 13.9746C41.967 14.1774 41.9918 14.3865 42.075 14.575V14.625C42.1542 14.8099 42.2858 14.9675 42.4535 15.0786C42.6211 15.1896 42.8176 15.2492 43.0187 15.25H43.125C43.4565 15.25 43.7745 15.3817 44.0089 15.6161C44.2433 15.8505 44.375 16.1685 44.375 16.5C44.375 16.8315 44.2433 17.1495 44.0089 17.3839C43.7745 17.6183 43.4565 17.75 43.125 17.75H43.0687C42.8676 17.7508 42.6711 17.8104 42.5035 17.9214C42.3358 18.0325 42.2042 18.1901 42.125 18.375Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M34.3339 31.56V35.56C34.3354 35.9314 34.2593 36.2989 34.1106 36.6392C33.9618 36.9794 33.7436 37.2848 33.47 37.5358C33.1964 37.7869 32.8733 37.978 32.5216 38.097C32.1698 38.2159 31.7971 38.2601 31.4272 38.2267C27.3243 37.7809 23.3832 36.3789 19.9206 34.1334C16.699 32.0862 13.9677 29.3549 11.9206 26.1334C9.6672 22.655 8.26489 18.6947 7.82723 14.5734C7.79391 14.2047 7.83773 13.833 7.9559 13.4822C8.07406 13.1313 8.26399 12.8089 8.51358 12.5355C8.76318 12.2621 9.06697 12.0436 9.40562 11.8941C9.74426 11.7445 10.1103 11.667 10.4806 11.6667H14.4806C15.1276 11.6603 15.755 11.8895 16.2456 12.3114C16.7362 12.7333 17.0567 13.3193 17.1472 13.96C17.3161 15.2401 17.6292 16.497 18.0806 17.7067C18.26 18.1839 18.2988 18.7026 18.1924 19.2012C18.0861 19.6998 17.839 20.1575 17.4806 20.52L15.7872 22.2134C17.6853 25.5514 20.4492 28.3153 23.7872 30.2134L25.4806 28.52C25.8431 28.1615 26.3008 27.9145 26.7994 27.8082C27.298 27.7018 27.8167 27.7406 28.2939 27.92C29.5036 28.3714 30.7605 28.6845 32.0406 28.8534C32.6883 28.9447 33.2798 29.271 33.7026 29.77C34.1254 30.2691 34.3501 30.9061 34.3339 31.56Z"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <clipPath id="clip0_sip_accounts">
        <rect width="15" height="15" fill="white" transform="translate(30 9)" />
      </clipPath>
    </defs>
  </svg>
);
